import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PermissionRoute = ({ requiredPermissions = [] }) => {
  const permissions  = useSelector((state) => state.permissions);

  const hasPermissions = requiredPermissions.every(perm =>
    permissions?.includes(perm)
  );

  return hasPermissions ? <Outlet /> : <Navigate to="/404" />;
};

export default PermissionRoute;